<template>
  <Content @back="back" :noBack="['expert','organ'].includes(userRole)">
    <template v-slot:nav_left> 球员管理 </template>
    <template v-slot:nav_right v-if="userRole !== 'coach' && isCanEditData">
      <div
        class="yioks_btn"
        @click="
          isAddPlayer = true;
          (isEdit = false), (playerInfo = {});
        "
      >
        添加球员
      </div>
      <div class="yioks_btn" @click="batchAdd = true">批量导入球员</div>
      <div class="yioks_btn" @click="download()">下载球员信息</div>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="select_box">
          <template v-if="userRole !== 'coach'">
             <select
                v-model="selectVal.organUuid"
                class="yioks_select"
                @change="changeOrg"
              >
                <option v-if="organList.length > 1" value="">全部区体育行政部门</option>
                <option
                  v-for="item in organList"
                  :key="item.organUuid"
                  :value="item.organUuid"
                >
                  {{ item.organShortName }}
                </option>
              </select>
              <select
                v-model="selectVal.youthUuid"
                class="yioks_select"
                @change="changeCenter"
              >
                <option v-if="centerList.length !== 1" value="">
                  全部培训机构
                </option>
                <option
                  v-for="item in centerList"
                  :key="item.uuid"
                  :value="item.uuid"
                >
                  {{ item.youthShortName }}
                </option>
              </select>
              <select
                v-model="selectVal.squadUuid"
                class="yioks_select"
                @change="changeQuery(true)"
              >
                <option v-if="squadList.length !== 1" value="">全部球队</option>
                <option
                  v-for="item in squadList"
                  :key="item.uuid"
                  :value="item.uuid"
                >
                  {{ item.shortName }}
                </option>
              </select>

          </template>
          <template v-else>
          <!-- coachSquadSelectList -->
           <select
                v-model="selectVal.squadUuid"
                class="yioks_select"
                @change="changeCoachCenter"
              >
                <option value="">
                  全部球队
                </option>
                <option
                  v-for="item in coachSquadSelectList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </option>
              </select>
          </template>
          <select
            v-model="selectVal.isSignUp"
            class="yioks_select"
            @change="changeQuery(true)"
          >
            <option value="">注册情况</option>
            <option value="2">已注册</option>
            <option value="1">未注册</option>
          </select>
          <select
            v-model="selectVal.focus"
            class="yioks_select"
            @change="changeQuery(true)"
          >
            <option value="2">全部学员</option>
            <option value="1">特别关注</option>
            <option value="3">外籍学员</option>
          </select>
        </div>
        <div class="search_box">
          <input
            v-model.trim="selectVal.seacherString"
            type="text"
            class="yioks_input"
            style="width: 140px"
            placeholder="请输入关键字"
            @keyup.enter="changeQuery(true)"
          />
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th idName"><strong>球员名字</strong></div>
              <!-- <div class="th organName"><strong>管理单位</strong></div>
              <div class="th centerName"><strong>单位</strong></div> -->
              <div class="th unionName"><strong>单位</strong></div>
              <div class="th idNumber"><strong>出生日期</strong></div>
              <div class="th gender"><strong>性别</strong></div>
              <div class="th age"><strong>年龄</strong></div>
              <div class="th iszhu"><strong>年度注册</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll>
              <div class="tbodyWrap">
                <div class="tbody">
                  <div v-for="(item, index) in player" :key="index" class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div
                      class="td idName"
                      :class="{ focusPlayer: item.focus === 1 }"
                    >
                      <p>{{ item.idName }}</p>
                    </div>
                    <!-- <div class="td organName">
                      <p>{{ item.organShortName }}</p>
                    </div>
                    <div class="td centerName">
                      <p>{{ item.youthShortName }}</p>
                    </div> -->
                    <div class="td unionName">
                      <p :title="item.workName">{{ item.workName }}</p>
                    </div>
                    <div class="td idNumber">
                      <p>{{ item.birthday | formatDateStamp }}</p>
                    </div>
                    <div class="td gender">
                      <p>{{ item.gender || '--' }}</p>
                    </div>
                    <div
                      class="td age"
                      :data-age="item.idNumber | filterIdNumber(2)"
                    >
                      <p v-if="item.birthday">{{ item.birthday | formateAgeFromNow }}岁</p>
                      <p v-else>{{ item.idNumber | formateAge }}岁</p>
                    </div>
                    <div class="td iszhu">
                      <p v-if="item.isSignUp === '2'">已注册</p>
                      <p v-else style="color:#f88594;">未注册</p>
                    </div>
                    <div class="td opt">
                      <p>
                        <span class="item" @click="goDetail(item.uuid)">查看</span>
                        <template v-if="userRole !== 'coach' && isCanEditData">
                          <span class="split">/</span>
                          <span class="item" @click="editPlayer(item,index)">编辑</span>
                        </template>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <template v-if="userRole !== 'coach'">
          <yioks-empty
            v-if="empty"
            tips="暂时没有数据 ~ "
            :name="isCanEditData ? '立即添加球员' : ''"
            @callback="
            addType = 'player';
            isAddPlayer = true;
            (isEdit = false), (playerInfo = {});
          "
          ></yioks-empty>
        </template>
        <template v-else>
          <yioks-empty
            v-if="empty"
            tips="暂时没有数据">
          </yioks-empty>
        </template>
      </div>
      <Pagination :total="total" :page.sync="page" />
      <template v-if="isAddPlayer">
        <AddPlayerDialog
          :addPlayer.sync="isAddPlayer"
          :isEdit="isEdit"
          :player="playerInfo"
          @hideDialog="hideDialog"
        ></AddPlayerDialog>
      </template>
      <yioks-tip
        :showTip="showTip"
        :tipMsg="$t('deletePlayerTips')"
        @callback="isDelete"
      />
      <el-dialog
        :visible.sync="batchAdd"
        width="500px"
        title="批量导入球员"
        :close-on-click-modal="false"
        custom-class="yioks_alert2"
      >
        <el-form
          ref="batchInfo"
          :model="batchInfo"
          :rules="formRules"
          label-width="80px"
        >
          <template v-if="userRole !== 'coach'">
             <el-form-item label="管理单位" prop="organUuid">
                <el-select
                  v-model.trim="batchInfo.organUuid"
                  style="width: 100%"
                  placeholder="请选择管理单位"
                  @change="changeBathOrg"
                >
                  <el-option
                    v-for="item in batchOrganList"
                    :key="item.organUuid"
                    :value="item.organUuid"
                    :label="item.organShortName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="单位" prop="youthUuid">
                <el-select
                  v-model.trim="batchInfo.youthUuid"
                  style="width: 100%"
                  placeholder="请选择管理单位后再选择单位"
                  @change="changeBathCenter"
                >
                  <el-option
                    v-for="item in batchCenterList"
                    :key="item.uuid"
                    :value="item.uuid"
                    :label="item.youthShortName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择球队" prop="squad">
                <el-select
                  v-model.trim="batchInfo.squadUuid"
                  style="width: 100%"
                  placeholder="请选择球队"
                >
                  <el-option
                    v-for="item in batchSquadList"
                    :key="item.uuid"
                    :value="item.uuid"
                    :label="item.shortName"
                  ></el-option>
                </el-select>
              </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="选择球队" prop="squadForCoach">
                <el-select
                  v-model.trim="batchInfo.squadForCoach"
                  style="width: 100%"
                  placeholder="请选择球队"
                  @change="changeBathOrgForCoach"
                >
                <!-- <el-option label="测试" value=""></el-option> -->
                  <el-option
                    v-for="item in coachSquadSelectList"
                    :key="item.key"
                    :value="item.key"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
          </template>



        </el-form>
        <UploadFile
          v-if="batchAdd"
          templateFileName="批量导入球员帐号模板文件.xlsx"
          request="/api/zuxie/guozi/player/upload/excel"
          :templateFile="tempUrl"
          @callBack="batchAddPlayer"
        />
      </el-dialog>
    </template>
  </Content>
</template>

<script>
import "vue-awesome/icons/regular/trash-alt";
import "vue-awesome/icons/regular/edit";
import player from "@/api/player";
import squad from "@/api/squad";
import common from "@/api/common";
import person from "@/assets/images/common/person.jpg";
import storage from "@/utils/storage";
// import formRules from '@/utils/formRules'
import rulesMixin from "@/utils/formRules/rulesMixin";
import { filterIdNumber, getAgeFromIdNumberYear } from "@/utils/yioks_filter";
import { squadNameList } from "@/utils/yioks_data";
import { idCard_number } from "@/assets/js/formRules";
import mixinAppConfig from "@/mixin/mixinAppConfig";
export default {
  components: {
    Content: () => import("@/components/layout/list"),
    Pagination: () => import("@/components/Pagination"),
    UploadFile: () => import("@/components/UploadFile"),
    // AddPlayerDialog: () => import("@/components/player"),
    AddPlayerDialog: () => import("@/components/player/PlayerAdd"),
  },
  filters: {
    filterIdNumber,
    getAgeFromIdNumberYear,
    formateAge(val) {
      if(val) {
        if(idCard_number(val)) {
          return getAgeFromIdNumberYear(val)
        } else {
          return '--'
        }
      } else {
        return '--'
      }
    },
    formateAgeFromNow(val) {
      if(!val) {
        return '--'
      } else {
        const moment = require('moment');
        const years = moment(val).format('yyyy');
        const nowYear = new Date().getFullYear();
        return (nowYear - Number(years))
      }
    },
  },
  mixins: [rulesMixin,mixinAppConfig],
  data() {
    return {
      downIng: false,
      player: "",
      total: 0,
      page: 0,
      pageSize: 20,
      empty: false,
      showList: false,
      person,
      organList: [],
      centerList: [],
      batchOrganList: [],
      batchCenterList: [],
      batchSquadList: [],
      squadList: [],
      isAddPlayer: false,
      selectVal: {
        organUuid: "",
        youthUuid: "",
        seacherString: "",
        squadUuid: "",
        isSignUp: "",
//        focus: storage.get("userInfo").userRole === 'system' ||  storage.get("userInfo").userRole === 'admin' ? 1 : 2,
        focus: 2,
      },
      batchInfo: {
        organUuid: "",
        organShortName: "",
        youthShortName: "",
        youthUuid: "",
        squadUuid: "",
        squadForCoach: '',  // 教练冗余数据
      },
      playerInfo: {
        idName: "",
        idNumber: "",
        headImgUrl: "",
        squadUuid: "",
        unit: "",
        position: "",
      },
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      showTip: false,
      addBtnLoading: false,
      loading: true,
      addBtn: false,
      allSquad: "",
      playerOption: "",
      playerUuid: "",
      isEdit: false,
      playerName: "",
      squadNameList,
      squadName: "",
      // formRules,
      batchAdd: false,
      uploadSuccess: false,
      batchSquadUuid: "",
      coachSquadSelectList: [], // 教练员专用搜索选项
    };
  },
  watch: {
    page() {
      this.changeQuery();
    },
    batchAdd(val) {
      if (!val) {
        // this.batchInfo = {
        //   organUuid: '',
        //   organShortName: '',
        //   youthShortName: '',
        //   youthUuid: '',
        //   squadUuid: ''
        // }
        // this.batchCenterList = []
        // this.batchSquadList = []
        this.batchInfo.squadUuid = "";
        this.$refs["batchInfo"].resetFields();
      }
    },
    // 'batchInfo.organUuid': {
    //   handler (val) {
    //     if (val) {
    //       this.batchCenterList = this.batchOrganList.find(item => {
    //         return item.organUuid === this.batchInfo.organUuid
    //       }).youthList
    //       this.batchInfo.organShortName = this.batchOrganList.find(item => {
    //         return item.organUuid === this.batchInfo.organUuid
    //       }).organShortName
    //     } else {
    //       this.batchCenterList = []
    //       this.batchInfo.youthShortName = ''
    //     }
    //     this.batchSquadList = []
    //     this.batchInfo.squadUuid = ''
    //   }
    // },
  },

  computed: {
    tempUrl() {
      const clubConfig = this.$store.getters.sysHostType;
      if (clubConfig === "club") {
        return "/uploads/templateFile/playerClub.xlsx";
      } else {
        return "/uploads/templateFile/player.xlsx";
      }
    },
  },

  created() {
    const { page, seacherString, squadUuid, organUuid, youthUuid, focus, isSignUp } =
      this.$route.query;
    page && (this.page = Number(page));
    seacherString && this.$set(this.selectVal, "seacherString", seacherString);
    organUuid && this.$set(this.selectVal, "organUuid", organUuid);
    youthUuid && this.$set(this.selectVal, "youthUuid", youthUuid);
    squadUuid && this.$set(this.selectVal, "squadUuid", squadUuid);
    focus && this.$set(this.selectVal, "focus", focus);
    isSignUp && this.$set(this.selectVal, "isSignUp", isSignUp);
    if (this.userRole === "coach") {
      this.getSearchSelectList();
    } else {
      this.getOrganListAndCenterList();
    }
    this.getPlayerList();
    // this.getCommonData()
  },
  methods: {
    back(){
      if ( this.userRole === "expert" || this.userRole === "organ"){
        this.$router.go(-1)
      }else if ( this.userRole === "admin"){
        this.$router.push('/home/index?details=mans')
      }else {
        this.$router.push('/home')
      }
    },
    getPlayerList() {
      this.loading = true;
      this.showList = false;
      this.empty = false;
      let request;
      if (this.userRole === "system" || this.userRole === "admin"|| this.userRole === "expert") {
        request = player.getPlayerSystem;
      } else if (this.userRole === "organ") {
        request = player.getPlayerOrgan;
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = player.getPlayerYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = player.getPlayerLeaderOrCoach;
      }
      let { focus, ...rest } = this.selectVal;
      if (+focus === 2) focus = 0;
      request({ page: this.page, size: this.pageSize, focus, ...rest })
        .then((res) => {
          this.loading = false;
          this.total = res.totalElements;
          if (res.content.length) {
            this.player = res.content;
            this.showList = true;
          } else {
            this.empty = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    getCommonData() {
      common.getAllSquad().then((res) => {
        this.allSquad = res;
      });
      common.getPlayerOption().then((res) => {
        this.playerOption = res;
      });
    },
    deletSquad(uuid) {
      this.playerUuid = uuid;
      this.showTip = true;
    },
    isDelete(isSure) {
      if (isSure) {
        player.deletePlayer(this.playerUuid).then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
          } else {
            this.getPlayerList();
            this.showTip = false;
          }
        });
      } else {
        this.showTip = false;
      }
    },
    editPlayer(row, index) {
      this.playerInfo = { ...this.player[index] };
      this.formRules.userUuid = this.playerInfo.uuid;
      this.isAddPlayer = true;
      this.isEdit = true;
    },
    goDetail(uuid) {
      this.$router.push({
        path: "info",
        query: {
          uuid,
        },
      });
    },
    batchAddPlayer(url) {
      this.$refs["batchInfo"].validate((valid) => {
        if (valid) {
          let data = {
            ...this.batchInfo,
            path: url,
            playerToSquads: [
              this.batchInfo,
            ]
          };
          player.batchAddLeader(data).then((res) => {
            this.batchAdd = false;
            this.getPlayerList();
          });
        }
      });
      // if (this.batchSquadUuid) {
      //   player.batchAddLeader({ filePath: url, squadUuid: this.batchSquadUuid }).then(res => {
      //     this.batchAdd = false
      //     this.getPlayerList()
      //   })
      // } else {
      //   this.$message.error('请选择球队')
      // }
    },
    getOrganListAndCenterList() {
      let data = this.uuid;
      let request;
      if (this.userRole === "organ") {
        request = squad.getOrgListByOrgan;
      } else if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        request = squad.getOrgListBySystem;
        data = "";
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = squad.getOrgListByYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = squad.getOrgListByCoachOrLeader;
      }
      request(data).then((res) => {
        this.organList = res;
        this.batchOrganList = res;
        if (this.selectVal.organUuid) {
          if (this.selectVal.youthUuid) {
            this.centerList =
              this.organList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            if (this.selectVal.squadUuid) {
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
            }
          }
        } else {
          if (this.organList.length === 1) {
            this.$set(this.selectVal, "organUuid", this.organList[0].organUuid);
            this.$set(
              this.batchInfo,
              "organUuid",
              this.batchOrganList[0].organUuid
            );
            this.$set(
              this.batchInfo,
              "organShortName",
              this.batchOrganList[0].organShortName
            );
            this.centerList =
              this.batchOrganList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            this.batchCenterList = this.centerList;
            if (this.centerList.length === 1) {
              this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
              this.$set(
                this.batchInfo,
                "youthUuid",
                this.batchCenterList[0].uuid
              );
              this.$set(
                this.batchInfo,
                "youthShortName",
                this.batchCenterList[0].youthShortName
              );
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
              this.batchSquadList = this.squadList;
              if (this.squadList.length === 1) {
                this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
                this.$set(this.batchInfo, "squadUuid", this.squadList[0].uuid);
              }
            }
          }
        }
      });
    },

    // 教练员搜索选项
    getSearchSelectList() {
      const _ = require("lodash");
      squad
        .getSquadListCoachAll()
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const uni_selectYouthList = _.unionBy(res, "squadUuid");
          this.coachSquadSelectList = uni_selectYouthList.map((item) => ({
            label: `${item.organShortName} - ${item.youthShortName} - ${ item.shortName }`,
            value: item.squadUuid,
            key: JSON.stringify({ squadUuid: item.squadUuid, youthUuid: item.youthUuid, organUuid: item.organUuid })
          }));
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
    changeOrg() {
      this.centerList = [];
      this.squadList = [];
      this.$set(this.selectVal, "youthUuid", "");
      this.$set(this.selectVal, "squadUuid", "");
      if (this.selectVal.organUuid) {
        const { youthList } = this.organList.find((item) => {
          return item.organUuid === this.selectVal.organUuid;
        });
        this.centerList = youthList || [];
        if (this.centerList.length === 1) {
          this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
          this.squadList =
            this.centerList.find((item) => {
              return item.uuid === this.selectVal.youthUuid;
            }).squadList || [];
          if (this.squadList.length === 1) {
            this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
          }
        }
      }
      this.changeQuery(true);
    },
    changeCenter() {
      this.squadList = [];
      this.$set(this.selectVal, "squadUuid", "");
      if (this.selectVal.youthUuid) {
        this.squadList =
          this.centerList.find((item) => {
            return item.uuid === this.selectVal.youthUuid;
          }).squadList || [];
        if (this.squadList.length === 1) {
          this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
        }
      }
      this.changeQuery(true);
    },
    changeCoachCenter() {
      this.changeQuery(true);
    },
    changeQuery(flag) {
      if (flag) this.page = 0;
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          seacherString: this.selectVal.seacherString,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
          squadUuid: this.selectVal.squadUuid,
          focus: this.selectVal.focus,
        },
      });
      this.getPlayerList();
    },
    hideDialog(val) {
      this.isAddPlayer = val;
      this.getPlayerList();
    },
    changeBathOrgForCoach(val) {
      if(val) {
        const parseData = JSON.parse(val);
        const {organUuid, squadUuid, youthUuid } = parseData
        this.batchInfo = Object.assign({}, this.batchInfo, {organUuid, squadUuid, youthUuid})
      }
    },
    changeBathCenter() {
      this.batchInfo.squadUuid = "";
      this.batchSquadList = [];
      this.batchInfo.youthShortName = "";
      if (this.batchInfo.youthUuid) {
        this.batchInfo.youthShortName =
          this.batchCenterList.find((item) => {
            return item.uuid === this.batchInfo.youthUuid;
          }).youthShortName || "";
        this.batchSquadList =
          this.batchCenterList.find((item) => {
            return item.uuid === this.batchInfo.youthUuid;
          }).squadList || [];
        if (this.batchSquadList.length === 1) {
          this.$set(this.batchInfo, "squadUuid", this.batchSquadList[0].uuid);
        }
      }
    },
    changeBathOrg() {
      this.batchSquadList = [];
      this.batchCenterList = [];
      this.$set(this.batchInfo, "youthUuid", "");
      this.$set(this.batchInfo, "organShortName", "");
      this.$set(this.batchInfo, "youthShortName", "");
      this.$set(this.batchInfo, "squadUuid", "");
      if (this.batchInfo.organUuid) {
        this.batchInfo.organShortName = this.batchOrganList.find((item) => {
          return item.organUuid === this.batchInfo.organUuid;
        }).organShortName;
        this.batchCenterList =
          this.batchOrganList.find((item) => {
            return item.organUuid === this.batchInfo.organUuid;
          }).youthList || [];
        if (this.batchCenterList.length === 1) {
          // this.$set(this.selectVal, 'youthUuid', this.centerList[0].uuid)
          this.$set(this.batchInfo, "youthUuid", this.batchCenterList[0].uuid);
          this.$set(
            this.batchInfo,
            "youthShortName",
            this.batchCenterList[0].youthShortName
          );
          this.batchSquadList =
            this.batchCenterList.find((item) => {
              return item.uuid === this.batchInfo.youthUuid;
            }).squadList || [];
          if (this.batchSquadList.length === 1) {
            this.$set(this.batchInfo, "squadUuid", this.batchSquadList[0].uuid);
          }
        }
      }
    },
    download() {
      if (this.downIng) return;
      this.downIng = true;
      let { focus, ...rest } = this.selectVal;
      if (+focus === 2) focus = 0;
      player.getDownloadPlayerSystem({ focus, ...rest })
      .then((res) => {
        const { fileName, filePath } = res;
        const transferPath = this.$yioksConfig.transferBaseOnly(filePath);
        common.downfile(transferPath, fileName);
        this.downIng = false;
      })
      .catch((err) => {
        this.downIng = false;
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        height 49px
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height 100%
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        color $color_white
    .organName
      width 15%
    .centerName
      width 18%
    .unionName
      width 29%
      p {
        padding 0 4px
      }
    .seq
      width 6%
    .idName
      width 15%
    .idNumber
      width 15%
    .gender, .age
      width 8%
    .iszhu
      width 10%
    .opt
      width 10%
      p
        width 100%
        text-align center
        .item
          cursor pointer
          user-select none
          color $green_color
        .split
          margin 0 5px
.demo-ruleForm
  height 475px
.tip
  margin-top 10px
  color red
  width 100%
  text-align center
  word-break break-word
.yioks_select
  width 110px !important
.focusPlayer
  p
    color #f88594 !important
</style>
